import { useEffect, useRef } from "react";
import { API } from "aws-amplify";
import { GetPodSession } from "../../graphql/queries";
import { commitQueueState, mergeReadRequests, requestKey } from "./urgentQueue";
export { commitQueueState, mergeReadRequests };

export function useClaimConfirmations({ readRequests, onSession, onConsumed }) {
  const attemptedRef = useRef(new Set());
  const inFlightRef = useRef(new Set());
  const mountedRef = useRef(true);
  const onSessionRef = useRef(onSession);
  const onConsumedRef = useRef(onConsumed);
  onSessionRef.current = onSession;
  onConsumedRef.current = onConsumed;

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const pending = (readRequests ?? []).filter((item) => {
      const key = requestKey(item);
      return item?.id && !attemptedRef.current.has(key) && !inFlightRef.current.has(key);
    });
    if (!pending.length) return undefined;

    pending.forEach((item) => {
      const key = requestKey(item);
      attemptedRef.current.add(key);
      inFlightRef.current.add(key);
      API.graphql({
        query: GetPodSession,
        variables: { id: item.id },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })
        .then(({ data }) => {
          if (!mountedRef.current) return;
          const session = data?.getPodSession;
          if (!session?.id) return;
          onSessionRef.current?.({
            type: "update",
            session,
            claimGeneration: item.generation,
          });
        })
        .catch((error) => {
          if (mountedRef.current) {
            console.error("Error confirming queue session:", error);
          }
        })
        .finally(() => {
          inFlightRef.current.delete(key);
        });
    });
    onConsumedRef.current?.(pending);
    return undefined;
  }, [readRequests]);
}
